import React, { useState, useEffect, Fragment } from "react";
import clienteAxios from "../../../config/axios";
import { Col, notification, Row } from "antd";
import Spin from "../../../components/Spin";
import "../Productos/Card_Secundaria/productos.scss";
import "../Productos/Cards_Normales/card_producto.scss";
/* import CardSecundaria from "../Productos/Card_Secundaria/card_secundaria";
import Card_Producto_Frente from "../Productos/Cards_Normales/card_producto_frente"; */
import Imagen_Banner from "./BannerOrientacion/imagenBanner";
import Card_Producto from "../Productos/Cards_Normales/card_producto";

// import Pagination from '../../../components/Pagination/pagination';
// import queryString from 'query-string';
// import ComponentProductos from '../Productos/componente_productos';
/* const gridStyle = { width: '100%', padding: 0, marginBottom: '1.5rem' }; */

function CardsProductos({ tipo, orientacion, banner, imagenLocal }) {
  //const { location, history } = props.propiedades;
  //const { page = 1 } = queryString.parse(location.search);

  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function obtenerProductos() {
      setLoading(true);
      await clienteAxios
        // tipo.categoria ? `categoria=${tipo.categoria}` : `temporada=${tipo.temporada}`
        .get(
          `/productos/filter?${
            tipo.categoria
              ? `categoria=${tipo.categoria}`
              : tipo.temporada
              ? `temporada=${tipo.temporada}`
              : `genero=${tipo.genero}`
          }`
        )
        .then((res, index) => {
          setProductos(res.data.posts);
          setLoading(false);
        })
        .catch((err) => {
          if (err.response) {
            notification.error({
              message: "Error",
              description: err.response.data.message,
              duration: 2,
            });
          } else {
            notification.error({
              message: "Error de conexion",
              description: "Al parecer no se a podido conectar al servidor.",
              duration: 2,
            });
          }
        });
    }

    obtenerProductos();
  }, [tipo]);

  const render = productos.map((productos, index) => {
    if (orientacion > 0) {
      if (orientacion === 1 && index === 0) {
        return (
          <Col
            key={index}
            xs={{ span: 12 }}
            md={{ span: 6 }}
            lg={{ span: 4 }}
            xl={{ span: 4 }}
            style={{ alignItems: "center" }}
          >
            <Imagen_Banner
              vincular={banner.vincular}
              imagen={banner.imagenBanner}
              link={banner.tipo}
              imagenLocal={imagenLocal}
            />
          </Col>
        );
      } else if (orientacion === 2 && index === 2) {
        return (
          <Col
            key={index}
            xs={{ span: 12 }}
            md={{ span: 6 }}
            lg={{ span: 4 }}
            xl={{ span: 4 }}
            style={{ alignItems: "center" }}
          >
            <Imagen_Banner
              vincular={banner.vincular}
              imagen={banner.imagenBanner}
              link={banner.tipo}
              imagenLocal={imagenLocal}
            />
          </Col>
        );
      } else if (orientacion === 3 && index === 4) {
        return (
          <Col
            key={index}
            xs={{ span: 12 }}
            md={{ span: 6 }}
            lg={{ span: 4 }}
            xl={{ span: 4 }}
            style={{ alignItems: "center" }}
          >
            <Imagen_Banner
              vincular={banner.vincular}
              imagen={banner.imagenBanner}
              link={banner.tipo}
              imagenLocal={imagenLocal}
            />
          </Col>
        );
      } else if (index <= 4) {
        return (
          <Col
            key={index}
            xs={{ span: 12 }}
            md={{ span: 6 }}
            lg={{ span: 4 }}
            xl={{ span: 4 }}
          >
            <Card_Producto productos={productos} imagenLocal={imagenLocal} />
          </Col>
        );
      }
    } else {
      if (index <= 4) {
        return (
          <Col key={index}  xs={{ span: 12 }} md={{ span: 6 }} lg={{ span: 4 }}>
            <Card_Producto productos={productos} />
          </Col>
        );
      }
    }
  });

  return (
    <Spin spinning={loading}>
      <Row justify="center" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        {render}
      </Row>
    </Spin>
  );
}

export default CardsProductos;
